import "@mdi/font/css/materialdesignicons.css"
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue              from "vue";
import Axios            from "axios";
import VueAxios         from "vue-axios";
import FlagIcon         from "vue-flag-icon";
import i18n             from "@/plugins/i18n";
import debug            from "@/plugins/debug";
//import draggable        from "@/plugins/draggable";
import numbers          from "@/plugins/numbers";
import objects          from "@/plugins/objects";
import Router           from "vue-router";
import routes           from "./routes";
import { store }        from "./store";
import { VueReCaptcha } from "vue-recaptcha-v3";
//import pdfMake          from "vue3-pdfmake";
import App              from "./App.vue";
import "./plugins/vuetify";
import DragDropTouch    from "drag-drop-touch";

import VueYandexMetrika from 'vue-yandex-metrika';

Vue.config.productionTip = false;
Vue.config.warnHandler = function(msg) {
    if (msg !== "The .native modifier for v-on is only valid on components but it was used on <div>.") {
        // eslint-disable-next-line
        console.error(msg)
    }
}

Vue.use(FlagIcon);
Vue.use(Router);
Vue.use(VueAxios, Axios);
Vue.use(DragDropTouch);
//Vue.use(pdfMake);

const router = new Router({ routes });

if (!("toJSON" in Error.prototype)) {
    Object.defineProperty(Error.prototype, "toJSON", {
        value: () => {
            let alt = {};

            Object.getOwnPropertyNames(this).forEach((key) => {
                alt[key] = this[key];
            }, this);

            return alt;
        },
        configurable: true,
        writable:     true
    });
}

if (!("capitalize" in String.prototype)) {
    Object.defineProperty(String.prototype, "capitalize", {
        value: () => {
            return this.charAt(0).toUpperCase() + this.slice(1);
        },
        enumerable: false
    });
}

Object.filter = (obj, predicate) =>
    Object.keys(obj)
          .filter(key => predicate(obj[key]) )
          .reduce((res, key) => (res[key] = obj[key], res), {} );

const r = Math.random();
fetch(process.env.BASE_URL + "data/config.json?r=" + r)
    .then((response) => response.json())
    .then((config) => {
        config.apiURL = config.apiURL.replaceAll("{{hostname}}", location.hostname).replaceAll("{{host}}", `${location.protocol}//${location.hostname}`);

        Vue.prototype.$config     = config;
        Vue.prototype.$debug      = debug;
        Vue.prototype.$num        = numbers;
        Vue.prototype.$obj        = objects;
        Vue.prototype.$noRedirect = [
            "/contacts",
            "/home",
            "/tariffs",
            "/tutorials"
        ];

        //console.log("config.recaptchaSiteKey", config.recaptchaSiteKey);

        Vue.use(VueReCaptcha, {
            siteKey: config.recaptchaSiteKey,
            loaderOptions: {
                useRecaptchaNet: true
            }
        });

        if (config.yandexMetrika) {
            Vue.use(VueYandexMetrika, {
                id: 90653791,
                router: router,
                env: process.env.NODE_ENV
                // other options
            })
        }

        new Vue({
            i18n,
            debug,
            //draggable,
            numbers,
            objects,
            store,
            router,
            //vuetify,
            render: (h) => h(App)
        }).$mount("#app");
    });
